import $ from 'jquery';
window.$ = $;

import './bootstrap';

import 'js-cookie';
import 'url-polyfill';

import './accordeon';
import './business';
import './cookie-popup';
import './cancel-request';
import './dashboard';
import './listing-form';
import './image-management';
import './listeo/slick.min';
import './listeo/chosen.min';
import 'timedropper';
import './listeo/datedropper';

import './mfp';
import './search-bar';
import './premium-search';
import './stars';
import './review';
import './messages';
import './mega-select';
import './global-request';
import './payment-accordeon';
import './slideout';
import './form-loader';
import './wysiwyg';
import './selects';

$(document).ready(function() {
    $('input.datedropper').dateDropper();
    $('#menu').removeClass('hidden');
});

function inlineCSS() {
    // Common Inline CSS
    $(".main-search-container, section.fullwidth, .listing-slider .item, .listing-slider-small .item, .address-container, .img-box-background, .image-edge, .edge-bg, .category-box").each(function () {
        var attrImageBG = $(this).attr('data-background-image');
        var attrColorBG = $(this).attr('data-background-color');

        if (attrImageBG !== undefined) {
            $(this).css('background-image', 'linear-gradient(to top,rgba(0,0,0,.33),rgba(33,33,33,.73)),url(' + attrImageBG + ')');
        }

        if (attrColorBG !== undefined) {
            $(this).css('background', '' + attrColorBG + '');
        }
    });
}

inlineCSS();

$(document).ready(function () {
    $('.fullwidth-slick-carousel').slick({
        centerMode: true,
        centerPadding: '15%',
        slidesToShow: 3,
        dots: true,
        arrows: false,
        responsive: [
            {
                breakpoint: 1441,
                settings: {
                    centerPadding: '10%',
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 1025,
                settings: {
                    centerPadding: '10px',
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    centerPadding: '10px',
                    slidesToShow: 1
                }
            }
        ]
    });

    $('.simple-slick-carousel').slick({
		infinite: true,
		slidesToShow: 3,
		slidesToScroll: 3,
		dots: true,
		arrows: true,
		responsive: [
		    {
		      breakpoint: 992,
		      settings: {
		        slidesToShow: 2,
		        slidesToScroll: 2
		      }
		    },
		    {
		      breakpoint: 769,
		      settings: {
		        slidesToShow: 1,
		        slidesToScroll: 1
		      }
		    }
	  ]
	});

    $('.listing-slider').slick({
		centerMode: true,
		centerPadding: '20%',
		slidesToShow: 2,
		responsive: [
			{
			  breakpoint: 1367,
			  settings: {
			    centerPadding: '15%'
			  }
			},
			{
			  breakpoint: 1025,
			  settings: {
			    centerPadding: '0'
			  }
			},
			{
			  breakpoint: 767,
			  settings: {
			    centerPadding: '0',
			    slidesToShow: 1
			  }
			}
		]
	});

    setTimeout(() => {
        inlineCSS();
    }, 300);

    $( window ).on( "resize", function() {
        inlineCSS();
    });
});

$(document).ready(function () {
    $('.td-input').timeDropper({
        format: 'HH:mm'
    });
});
